import { beautifyObjectKeys } from 'utils/helpers'
import { get, post, postWithoutBody, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  getCampaign(companyId = '', campaignId) {
    return get(`/members-api/campaign/${campaignId}/?companyFilter=${companyId}`)
  },
  saveCampaign(companyId = '', body) {
    return post(`/members-api/campaign/next?companyFilter=${companyId}`, body)
  },
  approveCampaign(campaignId) {
    return postWithoutBody(`/members-api/campaign/${campaignId}/approve`)
  },
  getParticipantsInfo(companyId = '', body) {
    return post(`/members-api/campaign/participants-info?companyFilter=${companyId}`, body)
  },
  getSelectedParticipantsDetails(companyId = '', body) {
    return post(`/members-api/campaign/select-participants?companyFilter=${companyId}`, body)
  },
  getParticipants(companyId = '', body, page, pageSize) {
    return post(
      buildURL('/members-api/campaign/participant-candidates/', {
        companyFilter: companyId,
        page,
        pageSize,
      }),
      body
    )
  },
  getScenarios(companyId = '', body) {
    return post(`/members-api/campaign/scenarios/suggestions?companyFilter=${companyId}`, body)
  },
  autoSelectScenarios(companyId = '', body) {
    const data = {
      ...body,
      participantsChoices: beautifyObjectKeys(body.participantsChoices),
      participantsExcludeChoices: beautifyObjectKeys(body.participantsExcludeChoices),
    }
    return post(`/members-api/campaign/scenarios/autoselection?companyFilter=${companyId}`, data)
  },
  getLandingPages(
    companyId = '',
    defaultLocaleId,
    selectedLocaleIds = [],
    createdBy,
    typeFilter = '',
    sortByUsage
  ) {
    return get(
      buildURL('/members-api/campaign/landing-pages', {
        companyFilter: companyId,
        defaultLocaleId,
        selectedLocaleIds: selectedLocaleIds.length ? selectedLocaleIds : undefined,
        createdBy,
        typeFilter,
        sortByUsage,
      })
    )
  },
  getTrainingVideos(companyId = '', vendor, localeIds) {
    return get(
      buildURL(
        '/members-api/trainings/',
        {
          companyFilter: companyId,
          vendor,
          localeIds,
        },
        true
      )
    )
  },
  getTestCampaignResults(campaignId) {
    return get(`/members-api/campaign/test/${campaignId}`)
  },
  postTryItOut({
    profileIds,
    campaignId,
    scenarios = [],
    trainingReminderIndices,
    sendNotifyManagerEmail,
    sendSimulationFailedEmail,
    sendTrainingCompletionEmail,
  }) {
    return post(`/members-api/campaign/test/${campaignId}`, {
      profile_ids: profileIds,
      templates: scenarios,
      campaign_id: campaignId,
      training_reminder_indices: trainingReminderIndices,
      send_training_completion_email: sendTrainingCompletionEmail,
      send_simulation_failed_email: sendSimulationFailedEmail,
      send_notify_manager_email: sendNotifyManagerEmail,
    })
  },
  sendUpgradePremiumVideo(companyId = '') {
    return get(`/members-api/campaign/upgrade-request?companyFilter=${companyId}`)
  },
  uploadVideoLink(url, localeId, trainingId) {
    const params = {
      url,
      localeId,
    }

    if (trainingId) {
      params.trainingId = trainingId
    }

    return post('/members-api/campaign/upload-training-videos', params)
  },
  getQuickLaunch(companyId = '') {
    return get(`/members-api/quick-campaign/?companyFilter=${companyId}`)
  },
  submitQuickLaunch(companyId = '', body) {
    return post(`/members-api/quick-campaign/?companyFilter=${companyId}`, body)
  },
  getDefaultTrainingData(companyId = '', localeId, trainingIds) {
    return get(
      buildURL(
        `/members-api/campaign/default-training-data/?companyFilter=${companyId}&localeId=${localeId}`,
        { trainingIds }
      )
    )
  },
  getEmailPreview(body, companyId = '') {
    return post(`/members-api/campaign/preview-training-email/?companyFilter=${companyId}`, body)
  },
  getEmails(companyId = '', campaignId) {
    return get(
      `/members-api/spear-phishing-scenarios/?companyFilter=${companyId}&campaignId=${campaignId}`
    )
  },
  updateEmail(scenarioId, data, companyId) {
    return put(
      `/members-api/spear-phishing-scenarios/${scenarioId}/?companyFilter=${companyId}`,
      data
    )
  },
  retrieveEmail(scenarioId, companyId) {
    return get(`/members-api/spear-phishing-scenarios/${scenarioId}/?companyFilter=${companyId}`)
  },
  createCustomTraining() {
    return post('/members-api/trainings/custom/')
  },
  getWizerCoursePreview(trainingId, languageCode = 'en', companyId = '') {
    return get(
      buildURL(`/members-api/trainings/${trainingId}/wizer-preview/`, {
        companyFilter: companyId,
        languageCode,
      })
    )
  },
  getTrainingPreview(trainingId, localeId, companyId = '') {
    return get(
      buildURL(`/members-api/trainings/${trainingId}/preview/`, {
        companyFilter: companyId,
        locale_id: localeId,
      })
    )
  },
})
